<template>
  <footer id="footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            <a
              href="https://huestimates.com/"
              class="font-weight-bold"
              target="_blank"
              >Progress</a
            >
              IMS Medical Account v.1.1.8762
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
<style>
#footer {
  padding: 10px; /* Отступы внутри подвала */
  margin-top: auto; /* Важное свойство для закрепления подвала внизу */
}
</style>